import { render, staticRenderFns } from "./fsnd.vue?vue&type=template&id=37bb5a36&scoped=true&"
import script from "./fsnd.vue?vue&type=script&lang=js&"
export * from "./fsnd.vue?vue&type=script&lang=js&"
import style0 from "./fsnd.vue?vue&type=style&index=0&id=37bb5a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bb5a36",
  null
  
)

export default component.exports